import React from 'react';
import { AccessibilityView } from './accessibility-view';
import { useGlobalState } from '../global/context/global-context';
import { useAccessibility } from '../global/context/accessibility-context';
import { BaseLayoutFactory } from '../global/base-layout-factory';

export const AccessibilityFactory: React.FC = () => {
  const { applicationData } = useGlobalState();
  const {
    fontSize,
    highContrast,
    increaseFontSize,
    decreaseFontSize,
    toggleHighContrast,
    resetAccessibility,
  } = useAccessibility();

  return (
    <BaseLayoutFactory>
      <AccessibilityView
        entityName={applicationData?.entity?.nickName}
        fontSize={fontSize}
        highContrast={highContrast}
        onIncreaseFontSize={increaseFontSize}
        onDecreaseFontSize={decreaseFontSize}
        onToggleHighContrast={toggleHighContrast}
        onResetAccessibility={resetAccessibility}
      />
    </BaseLayoutFactory>
  );
};
